function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 6,
  transform: "translate(-0.147 -0.147)",
  fill: "#7e7e7e"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.969,7.171v4.062a1.287,1.287,0,0,0,.134.734.729.729,0,0,0,.521.182v.44H6.7v-.44a.706.706,0,0,0,.533-.209,1.287,1.287,0,0,0,.115-.707V8.521a1.3,1.3,0,0,0-.133-.733A.712.712,0,0,0,6.7,7.606V7.171ZM8.158,4.545a.893.893,0,0,1,.9.9.853.853,0,0,1-.264.632.869.869,0,0,1-.634.261.892.892,0,0,1-.892-.893.871.871,0,0,1,.261-.634A.854.854,0,0,1,8.158,4.545Z",
  transform: "translate(-6.698 -4.545)",
  fill: "#fff"
});

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.147 0.147)"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.403 1.794)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _ref3))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-icon.259068ea.svg";
export { ForwardRef as ReactComponent };